import { getPresignedS3UploadLink } from './get-presigned-s3-upload-link'
import { uploadAnaloguesExcelFiles } from './upload-analogues-excel-files'
import { uploadFileToS3 } from './upload-file-to-s3'

export const analoguesApi = {
  getPresignedS3UploadLink,
  uploadAnaloguesExcelFiles,
  uploadFileToS3,
}
